import { render, staticRenderFns } from "./IconEditAction.vue?vue&type=template&id=8b327bba&"
import script from "./IconEditAction.vue?vue&type=script&lang=ts&"
export * from "./IconEditAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports